import { ContainerJourneyDto, ContainerService, reportsService } from '@tom-ui/integration'
import { makeObservable, observable, runInAction } from 'mobx'

type Uncap<T> = {
  [K in keyof T as `${Uncapitalize<string & K>}`]: T[K]
}

const mapToUncap = <T extends object>(dto: T): Uncap<T> => {
  const uncapped: any = {}
  Object.keys(dto).forEach(key => {
    uncapped[key.charAt(0).toLowerCase() + key.slice(1)] = dto[key as keyof T]
  })

  return uncapped
}

export type ContainerJourneyReportDto = Uncap<Omit<ContainerJourneyDto, 'Services'>> & {
  services: ContainerJourneyService[]
}

export type ContainerJourneyService = Uncap<ContainerService>

export class ContainerJourneyReportDataStore {
  journeyData: ContainerJourneyReportDto[] = []

  constructor() {
    makeObservable(this, {
      journeyData: observable,
    })
  }

  fetch = async (from: Date, to: Date, vesselVisitId?: number) => {
    const result: ContainerJourneyDto[] = await reportsService.getContainerJourneys(
      from,
      to,
      vesselVisitId,
    )

    runInAction(() => {
      this.journeyData = result.map(dto => ({
        ...mapToUncap(dto),
        services: dto.Services?.map(mapToUncap) ?? [],
      }))
    })
  }
}
